import { Data } from './Data';
import { Header } from './Header';

export const CodeCell = { Data, Header };
